<template>
  <div class="NotWiki">
    <b-container fluid>
    <b-row>
    <b-col md="12">
      <a class="float-sm-left" href="https://github.com/CHIMEFRB/frb-web/blob/master/src/components/events.vue" target="_blank" style="color:black">
        <b-icon icon="github" aria-hidden="true" font-scale="1.0"></b-icon>
      </a>
      <div class="text-center" id="welcome">
      </div>
      <h2>This is not the wiki :) (Hacked together quickly, improvements to come)</h2>
      <h2 id="event-heading">FRB Candidates</h2>
    </b-col>
    </b-row>
    <b-row>
        <b-col md="4" class="my-1">
          <b-form-group horizontal label="Filter" class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Type to Search" />
              <b-input-group-append>
                <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="4" class="my-1">
          <b-form-group horizontal label="Per page" class="mb-0">
            <b-form-select :options="pageOptions" v-model="perPage" />
          </b-form-group>
        </b-col>
        <b-col md="4" class="my-1">
          <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
        </b-col>
      </b-row>
      <!-- Main table element -->
      <div v-if = "items.length === 0">
        <b-spinner
              v-for="variant in variants"
                :variant="variant"
                :key="variant"
              type="grow"
        >
          Fetching data...
        </b-spinner>
      </div>
      <div v-else>
        <b-table
               show-empty
               :stacked="md"
               :items="items"
               :fields="fields"
               :small="smallTable"
               :current-page="currentPage"
               :per-page="perPage"
               :filter="filter"
               :sort-by.sync="sortBy"
               :sort-desc.sync="sortDesc"
               :sort-direction="sortDirection"
               @filtered="onFiltered"
        >
        </b-table>
      </div>
    </b-container>
  </div>
</template>

<script>
import { AuthVerificationMixin } from '../mixins/auth_mixin.js'

var baseUrl = 'https://frb.chimenet.ca/frb-master/'

var fields = [
  {key: 'count', label: 'Number', 'class': 'text-center'},
  {key: 'event_id', label: 'Event No', 'class': 'text-center'},
  // {key: 'event_type', label: 'Type', 'class': 'text-center'},
  {key: 'datetime', label: 'Datetime (UTC)', 'class': 'text-center'},
  {key: 'dm', label: 'DM', 'class': 'text-center'},
  {key: 'snr', label: 'SNR', 'class': 'text-center'},
  {key: 'ra', label: 'Right Ascension', 'class': 'text-center'},
  {key: 'dec', label: 'Declination', 'class': 'text-center'}
]
export default {
  mixins: [AuthVerificationMixin],
  data () {
    return {
      baseUrl: baseUrl,
      items: [],
      fields: [],
      smallTable: true,
      dark: false,
      fixed: true,
      sortBy: null,
      plot: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      currentPage: 1,
      perPage: 50,
      pageOptions: [ 5, 10, 15, 50, 100 ],
      variants: ['primary', 'secondary', 'danger', 'warning', 'success', 'info', 'dark']
    }
  },
  mounted () {
    this.reloadWindow()
    if (this.user) {
      document.getElementById('welcome').innerHTML = 'Welcome @' + localStorage.username
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.fetchVerifications(authHeaders)
    }
  },
  computed: {
    sortOptions () {
      // Create an options list from our fields
      return this.showfields
        .filter(f => f.sortable)
        .map(f => { return { text: f.label, value: f.key } })
    },
    totalRows () {
      return this.items.length
    }
  },
  methods: {
    fetchVerifications (authHeaders) {
      var url = this.baseUrl + 'v1/verification/get-verifications/NEW CANDIDATE'
      this.$http.get(url, {headers: authHeaders})
        .then(response => {
          this.fields = fields
          this.parseResponse(response.body)
        }, response => {
        })
    },
    parseResponse (events) {
      this.items = []
      this.userVerificationItemsToShow = {}
      this.qualityFactorItemsToShow = {}
      let count = 0
      events.reverse()
      for (var i = 0; i < events.length; i++) {
        count = count + 1
        var item = {}
        item['event_id'] = events[i]['id']
        item['datetime'] = events[i]['datetime'].slice(0, 23)
        item['_rowVariant'] = 'success'
        item['variant'] = 'success'
        item['dm'] = events[i]['dm'].toFixed(2)
        item['snr'] = events[i]['snr'].toFixed(2)
        item['ra'] = events[i]['ra'].toFixed(2)
        item['dec'] = events[i]['dec'].toFixed(2)
        // item['event_type'] = events[i]['event_type']
        item['count'] = count
        this.items.push(item)
      }
      this.items.reverse()
      document.getElementById('event-heading').innerHTML = 'FRB Candidates' + ': ' + this.items.length
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Science/NotWiki.vue